export { default as RecentActivity } from "./RecentActivity.vue";